import React, { Component } from 'react';
import MobileAuthentication from './MobileAuthentication';
import ABHANumberVerification from './ABHANumberVerification';

import './Abha.css'; // Assuming CSS is shared
import { Button } from 'react-bootstrap';
import AbhaAddressverfi from './AbhaAddressverfi';

export default class ABHAVerificationflow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'mobile',
    };
  }

  handleTabChange = (tabName) => {
    this.setState({ activeTab: tabName });
  };

  renderTabContent = () => {
    const { activeTab } = this.state;

    switch (activeTab) {
      // case 'aadhar':
      //   return (
      //   //   <div style={{ padding: '20px' }}>
      //   //     <h5>Download by Aadhaar Number</h5>
      //   //     {/* Your Aadhaar form or content here */}
      //   //     <p>Coming soon...</p>
      //   //   </div>
      //   <Aadhaarcollection/>
      //   );
      case 'mobile':
        return <MobileAuthentication />;
      case 'abhanumber':
        return (
         <ABHANumberVerification/>
        );
        case 'abhaaddress':
            return (
             <AbhaAddressverfi/>
            );
            
      default:
        return null;
    }
  };

  render() {
    const { activeTab } = this.state;

    return (
      <div style={{ padding: '20px' }}>
        <h4 className="mb-3">ABHA Verification</h4>
        <div className="d-flex gap-2 mb-4">
            
          {/* <Button
            variant={activeTab === 'aadhar' ? 'primary' : 'outline-primary'}
            onClick={() => this.handleTabChange('aadhar')}
          >
            Aadhaar Number
          </Button> */}
          <Button
            variant={activeTab === 'mobile' ? 'primary' : 'outline-primary'}
            onClick={() => this.handleTabChange('mobile')}
          >
            Mobile Number
          </Button>
          <Button
            variant={activeTab === 'abhanumber' ? 'primary' : 'outline-primary'}
            onClick={() => this.handleTabChange('abhanumber')}
          >
            ABHA Number
          </Button>
          <Button
            variant={activeTab === 'abhaaddress' ? 'primary' : 'outline-primary'}
            onClick={() => this.handleTabChange('abhaaddress')}
          >
            ABHA Address
          </Button>
        </div>

        <div className="tab-content-wrapper">{this.renderTabContent()}</div>
      </div>
    );
  }
}
